import React, { useCallback, useEffect, useState } from 'react';
import { useAppSelector } from 'store/hooks';

import Report from '@/components/Project/Operate/Report';
import GoogleMint from '@/components/Project/Operate/GoogleMint';
import Track from '@/components/Project/Operate/Track';
import { Project } from 'api/raffle/raffle_detail';

const Banner = () => {
  const {
    raffleInfo: { project },
  } = useAppSelector((state) => state.raffleDetails);
  const [bannerLink, setBannerLink] = useState('');
  const [raffleProject, setRaffleProject] = useState<Project>();

  useEffect(() => {
    setBannerLink(String(project?.banner));
    setRaffleProject(project);
  }, [project, project?.banner]);

  const Operate = useCallback(() => {
    return (
      <div className="absolute bottom-0 left-0 right-0 top-0">
        <div className="absolute right-3 top-3 flex items-center justify-end gap-4 ">
          <GoogleMint
            date={raffleProject?.mint_date as any}
            time={raffleProject?.mint_time as string}
            name={encodeURIComponent(raffleProject?.name as string) || ''}
            blockchain={raffleProject?.blockchain}
            publicPrice={raffleProject?.public_price as any}
            supply={Number(raffleProject?.supply_count) || 0}
            website={raffleProject?.website as string}
            wl={raffleProject?.whitelist_price as any}
            project={raffleProject}
          />
          <Report project={raffleProject} />
          <Track
            id={Number(raffleProject?.id)}
            mintDate={raffleProject?.mint_date}
            isTracked={raffleProject?.is_tracked}
          />
        </div>
      </div>
    );
  }, [raffleProject]);

  const raffleBannerRender = useCallback(() => {
    if (!!bannerLink) {
      return (
        <div className=" box-border h-[200px] w-full overflow-hidden rounded-2xl">
          <img
            src={bannerLink}
            className="h-full w-full object-cover"
            onError={(e: any) => {
              e.target.src =
                'https://s.luckygo.io/luckybuy/img/detailDefaultBanner2.png';
            }}
            alt=""
          />
        </div>
      );
    } else {
      return (
        <div className=" box-border h-[200px] w-full overflow-hidden rounded-2xl">
          <img
            src="https://s.luckygo.io/luckybuy/img/detailDefaultBanner2.png"
            className="h-full w-full object-cover"
            alt=""
          />
        </div>
      );
    }
  }, [bannerLink]);

  return (
    <div className="relative">
      <div>{raffleBannerRender()}</div>
      <div>{Operate()}</div>
    </div>
  );
};

export default Banner;
